import { TableProps } from 'core-ui';
import { memo } from 'react';
import { StyledTable } from './styled';

const CustomTable = (props: TableProps) => {
  return <StyledTable {...props} />;
};

export default memo(CustomTable);
